import { XmlSchemaAnnotated } from '../XmlSchemaAnnotated';

export abstract class XmlSchemaSimpleTypeContent extends XmlSchemaAnnotated {}
